export const CAMPAIGN_STATUSES = ['draft', 'active', 'paused', 'archived'];

export const CAMPAIGN_STATUS_META = {
  draft:    { label: 'Draft',    tone: 'bg-gray-500/10 text-gray-300 border-gray-500/20' },
  active:   { label: 'Active',   tone: 'bg-emerald-500/10 text-emerald-300 border-emerald-500/20' },
  paused:   { label: 'Paused',   tone: 'bg-amber-500/10 text-amber-300 border-amber-500/20' },
  archived: { label: 'Archived', tone: 'bg-gray-500/10 text-gray-600 border-gray-500/20' },
};

export const ENROLLMENT_STATUS_META = {
  active:       { label: 'Active',       tone: 'bg-blue-500/10 text-blue-300 border-blue-500/20' },
  paused:       { label: 'Paused',       tone: 'bg-amber-500/10 text-amber-300 border-amber-500/20' },
  completed:    { label: 'Completed',    tone: 'bg-emerald-500/10 text-emerald-300 border-emerald-500/20' },
  bounced:      { label: 'Bounced',      tone: 'bg-red-500/10 text-red-300 border-red-500/20' },
  unsubscribed: { label: 'Unsubscribed', tone: 'bg-gray-500/10 text-gray-500 border-gray-500/20' },
};

export function campaignStatusMeta(s) {
  return CAMPAIGN_STATUS_META[s] || { label: s || '—', tone: 'bg-gray-500/10 text-gray-400 border-gray-500/20' };
}
export function enrollmentStatusMeta(s) {
  return ENROLLMENT_STATUS_META[s] || { label: s || '—', tone: 'bg-gray-500/10 text-gray-400 border-gray-500/20' };
}

export function fmtPercent(n) {
  if (n == null || Number.isNaN(n)) return '—';
  return `${(n * 100).toFixed(1)}%`;
}

// Contact roles selectable for campaign targeting. Values mirror
// CONTACT_ROLES_SCHOOL in functions/api/_lib/validators.js — the stored
// contacts.role values — so a targeting role actually matches contacts.
// (The older UI vocabulary 'ap' / 'tech_lead' never matched any contact row.)
export const CONTACT_ROLE_OPTIONS = [
  { value: 'principal',           label: 'Principal' },
  { value: 'assistant_principal', label: 'Assistant principal' },
  { value: 'parent_coordinator',  label: 'Parent coordinator' },
  { value: 'purchase_secretary',  label: 'Purchasing secretary' },
  { value: 'it_staff',            label: 'IT staff' },
  { value: 'superintendent',      label: 'Superintendent' },
  // Contacts filed under "Other (school)" (custom job titles live in
  // contacts.role_title) — a real, targetable role the server already accepts.
  { value: 'other_school',        label: 'Other (school)' },
];
export const CONTACT_ROLE_LABELS = Object.fromEntries(
  CONTACT_ROLE_OPTIONS.map((r) => [r.value, r.label]),
);
export function contactRoleLabel(value) {
  return CONTACT_ROLE_LABELS[value] || value;
}
